import SectionJobCategories from "../../sections/about/section-job-categories";
import SectionHowItWorks from "../../sections/about/section-how-it-works";
import SectionUploadCV from "../../sections/about/section-upload-cv";
import SectionTopCompanies from "../../sections/about/section-top-companies";
import { useEffect } from "react";
import { loadScript } from "../../../../../globals/constants";

function AboutUsPage() {

    useEffect(() => {
        loadScript("js/custom.js");
    })

    return (
        <>
      <style>{`
        :root {
          --primary-color: #0066cc;
          --secondary-color: #004a99;
          --accent-color: #da252e;
          --light-bg: #f8f9fa;
        }

        .hero {
          background: linear-gradient(135deg, #455192 0%, #004a99 100%);
          color: white;
          position: relative;
          overflow: hidden;
          box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
        }

        .hero::before {
          content: '';
          position: absolute;
          top: -50%;
          right: -20%;
          width: 500px;
          height: 500px;
          background: rgba(255, 255, 255, 0.05);
          border-radius: 50%;
        }

        .hero::after {
          content: '';
          position: absolute;
          bottom: -30%;
          left: -10%;
          width: 400px;
          height: 400px;
          background: rgba(255, 255, 255, 0.03);
          border-radius: 50%;
        }

        .hero .container {
          position: relative;
          z-index: 1;
        }

        .section-title {
          font-weight: 700;
          color: #fff;
          margin-bottom: 1.5rem;
          position: relative;
          display: inline-block;
        }

        .section-title::after {
          content: '';
          position: absolute;
          bottom: -8px;
          left: 0;
          width: 60px;
          height: 4px;
          background: var(--accent-color);
          border-radius: 2px;
        }

        .card-ghost {
          background: rgba(255, 255, 255, 0.95);
          border: none;
          border-radius: 15px;
          backdrop-filter: blur(10px);
          box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
          transition: transform 0.3s ease, box-shadow 0.3s ease;
        }

        .card-ghost:hover {
          transform: translateY(-5px);
          box-shadow: 0 12px 48px rgba(0, 0, 0, 0.15);
        }

        .card-ghost h4 {
          color: var(--primary-color);
          font-weight: 700;
          border-bottom: 2px solid var(--accent-color);
          padding-bottom: 10px;
          margin-bottom: 15px;
        }

        .card-ghost li {
          padding: 8px 0;
          border-bottom: 1px solid rgba(0, 0, 0, 0.05);color:#333;
        }

        .card-ghost li:last-child {
          border-bottom: none;
        }

        .feature-icon {
          width: 50px;
          height: 50px;
          background:linear-gradient(135deg, #455192 0%, #004a99 100%);
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-size: 24px;
          margin-bottom: 15px;
          box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
        }

        .message-section {
          background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
          border-radius: 20px;
          padding: 3rem 2rem;
          box-shadow: 0 10px 40px rgba(0, 0, 0, 0.08);
        }

        .section-title-dark {
          font-weight: 700;
          color: var(--secondary-color);
          margin-bottom: 2rem;
          position: relative;
          display: inline-block;
        }

        .section-title-dark::after {
          content: '';
          position: absolute;
          bottom: -8px;
          left: 0;
          width: 60px;
          height: 4px;
          background: var(--accent-color);
          border-radius: 2px;
        }

        .message-card {
          background: white;
          border-radius: 15px;
          padding: 2rem;
          box-shadow: 0 8px 30px rgba(0, 0, 0, 0.08);
          position: relative;
        }

        .message-card::before {
          content: '"';
          position: absolute;
          top: 20px;
          left: 20px;
          font-size: 60px;
          color: var(--primary-color);
          opacity: 0.1;
          font-family: Georgia, serif;
          line-height: 1;
        }

        .quote {
          font-style: italic;
          font-size: 1.1rem;
          color: var(--primary-color);
          font-weight: 500;
          margin-bottom: 1.5rem;
          padding-left: 20px;
          border-left: 4px solid var(--accent-color);
        }

        .md-image {
          border-radius: 15px;
          box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
          overflow: hidden;
          transition: transform 0.3s ease;
        }

        .md-image:hover {
          transform: scale(1.02);
        }

        .md-image img {
          width: 100%;
          height: auto;
          display: block;
        }

        .vision-section {
          background: white;
          border-radius: 20px;
          padding: 3rem 2rem;
          box-shadow: 0 10px 40px rgba(0, 0, 0, 0.05);
        }

        .values-list {
          list-style: none;
          padding: 0;
        }

        .values-list li {
          padding: 15px 20px;
          margin-bottom: 15px;
          background: linear-gradient(135deg, #f5f7fa 0%, #e3e7f0 100%);
          border-radius: 12px;
          border-left: 4px solid var(--primary-color);
          transition: all 0.3s ease;
        }

        .values-list li:hover {
          transform: translateX(10px);
          box-shadow: 0 5px 20px rgba(0, 102, 204, 0.15);
          border-left-color: var(--accent-color);
        }

        .values-list strong {
          color: var(--primary-color);
          font-size: 1.1rem;
        }

        .certification-card {
          background: linear-gradient(135deg, #455192 0%, #004a99 100%);
          color: white;
          border-radius: 15px;
          padding: 2rem;
          height: 100%;
          box-shadow: 0 10px 30px rgba(0, 102, 204, 0.2);
          transition: transform 0.3s ease;
        }

        .certification-card:hover {
          transform: translateY(-5px);
        }

        .certification-card h4 {
          color: white;
          border-bottom: 2px solid var(--accent-color);
          padding-bottom: 10px;
          margin-bottom: 15px;
        }

        .stat-number {
          font-size: 2rem;
          font-weight: 700;
          color: var(--accent-color);
        }

        .highlight-box {
          background: rgba(255, 107, 53, 0.1);
          padding: 3px 8px;
          border-radius: 5px;
          color: var(--accent-color);
          font-weight: 600;
        }

        .check-icon {
          color: var(--accent-color);
          margin-right: 0.5rem;
          margin-top: 0.25rem;
        }

        @media (max-width: 768px) {
          .hero {
            padding: 2rem 1rem !important;
          }
          
          .message-section, .vision-section {
            padding: 2rem 1rem;
          }

          .values-list {
            margin-left: 0 !important;
            padding-left: 0 !important;
          }
        }
      `}</style>

      <section className="hero rounded-3 mb-5 p-5">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-8 mb-4 mb-lg-0">
              <h2 className="h5 section-title">About Us</h2>
              <p className="mt-4">
                Incorporated in Mumbai in 2020, <strong>Seagull Staffing Solutions</strong> is a boutique executive search firm dedicated to helping organisations across India and the wider APAC region hire outstanding leaders. From a small founding team of three professionals, Seagull has grown into a focused practice of over 20 specialists delivering high-quality recruitment and selection services across industry verticals.
              </p>

              <p className="">
                Since inception, we have successfully placed more than <strong>200 professionals</strong> across functions and built a reputation for delivering precise, fit-for-purpose leadership hires. Today Seagull serves 50+ clients across sectors including Consumer, Paints & Chemicals, Pharma & Life Sciences, Large Corporates, BFSI, Engineering & Manufacturing, and more.
              </p>

              <h3 className="h6 mt-4 mb-3" style={{ color: '#fff', fontSize: '1.2rem' }}>What sets us apart</h3>
              <div className="row g-3">
                <div className="col-md-4">
                  <div className="d-flex align-items-start">
                    <span className="check-icon">✓</span>
                    <span>Specialist focus on leadership and senior appointments</span>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="d-flex align-items-start">
                    <span className="check-icon">✓</span>
                    <span>Large, categorized talent database with rigorous assessment</span>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="d-flex align-items-start">
                    <span className="check-icon">✓</span>
                    <span>Blend of experience, instincts and modern analytics</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-4">
              <aside className="card-ghost p-4">
                <h4 className="h6 mb-3">📊 Snapshot</h4>
                <ul className="list-unstyled mb-0">
                  <li><span style={{ color: 'var(--primary-color)' }}>📅</span> <strong>Year founded:</strong> 2020</li>
                  <li><span style={{ color: 'var(--primary-color)' }}>📍</span> <strong>Headquarters:</strong> Mumbai, India</li>
                  <li><span style={{ color: 'var(--primary-color)' }}>👥</span> <strong>Team size:</strong> 20+ professionals</li>
                  <li><span style={{ color: 'var(--primary-color)' }}>💼</span> <strong>Placements:</strong> <span className="stat-number">200+</span> senior hires</li>
                  <li><span style={{ color: 'var(--primary-color)' }}>🤝</span> <strong>Clients:</strong> 50+ across sectors</li>
                </ul>
              </aside>
            </div>
          </div>
        </div>
      </section>

      <section className="mb-5">
        <div className="container">
          <div className="message-section">
            <h2 className="h5 section-title-dark mb-4">Message from the Managing Director</h2>
            <div className="row g-4 align-items-center">
              <div className="col-lg-7">
                <div className="message-card">
                  <p className="quote">"Take care of the means, the ends take care of themselves." — Mahatma Gandhi</p>
                  <p>
                    Recruitment — especially at leadership level — blends the precision of science with the nuance of long-term relationship building. At Seagull, we combine deep domain experience, instinctive judgement and contemporary analytical tools to identify candidates who are not only capable but are the right cultural and strategic fit.
                  </p>
                  <div className="mt-4 pt-3 border-top">
                    <p className="mb-1" style={{ color: '#666' }}>Warm regards,</p>
                    <p className="fw-bold mb-0 fs-5" style={{ color: 'var(--secondary-color)' }}>Dr. Sureshkumar Madhusudanan</p>
                    <small className="text-muted">Managing Director, Seagull Group of Companies</small>
                  </div>
                </div>
              </div>
              <div className="col-lg-5">
                <div className="md-image">
                  <img src="assets/images/MDFinal.jpg" alt="Dr. Sureshkumar Madhusudanan" className="img-fluid" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="mb-5">
        <div className="container">
          <div className="vision-section">
            <h2 className="h5 section-title-dark mb-4">Our Vision & Values</h2>
            <div className="row g-4">
              <div className="col-lg-8">
                <div className="mb-4">
                  <div className="d-flex align-items-center mb-3">
                    <div className="feature-icon me-3">
                      👁️
                    </div>
                    <h3 className="h5 mb-0" style={{ color: 'var(--secondary-color)' }}>Vision</h3>
                  </div>
                  <p className="fs-5 ms-5 ps-2">To be the most preferred business partner in enabling organisational growth and performance through leadership hiring and talent advisory.</p>
                </div>

                <div className="mt-5">
                  <div className="d-flex align-items-center mb-4">
                    <div className="feature-icon me-3">
                      💎
                    </div>
                    <h3 className="h5 mb-0" style={{ color: 'var(--secondary-color)' }}>Core Values</h3>
                  </div>
                  <ul className="values-list ms-5 ps-2">
                    <li><strong>Integrity</strong> — We place unquestionable integrity at the heart of our leadership work.</li>
                    <li><strong>Ethical Practice</strong> — We maintain high ethical standards across every stage of the recruitment process.</li>
                    <li><strong>Deliver Value</strong> — We aim to exceed expectations and deliver measurable value to clients.</li>
                    <li><strong>Trust</strong> — Trust is central to our client and candidate relationships.</li>
                    <li><strong>Simplicity</strong> — We prefer clear and effective solutions over unnecessary complexity.</li>
                  </ul>
                </div>
              </div>

              <div className="col-lg-4">
                <div className="certification-card">
                  <h4 className="h6">🏆 Certifications & Recognition</h4>
                  <p className="mb-3">Seagull is ISO-certified and has been recognised for high standards in service delivery.</p>
                  <p className="mb-0">We are proud of the trust our clients place in us and the awards that reflect our commitment to excellence.</p>
                  <div className="mt-4 text-center">
                    <span style={{ fontSize: '60px', opacity: 0.3 }}>🎖️</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
    )
}

export default AboutUsPage;